import { Message } from "@apis:message/message";
import { groupBy, map } from "lodash";

export const groupReferences = (
  references: Message["GET_ONE"]["Response"]["docs"],
) => {
  // Group by title + content + reference to ensure uniqueness
  const grouped = groupBy(references, (ref) => {
    const title = ref.title || "";
    const content = ref.content || "";
    const reference = ref.reference || "";

    return `${title}_${content}_${reference}`;
  });

  return map(grouped, (group) => group[0]);
};
